import React from 'react';
import './Switch.scss';

interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    label?: string;
    name?: string;
    className?: string;
}

export const Switch: React.FC<SwitchProps> = ({ checked, onChange, disabled = false, label, name, className = '', ...props }) => {
    return (
        <label className={`switch-wrapper ${className}`}>
            {label && <span className="switch-label">{label}</span>}
            <div className={`switch ${checked ? 'active' : ''} ${disabled ? 'disabled' : ''}`}>
                <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} disabled={disabled} name={name} />
                <span className="slider" />
            </div>
        </label>
    );
};
